import { IChatV2UserSchema } from '@cian/chats-api';

import { IUserInChatListSchema } from '../../types/userData';

export const mapUserV2VersionToV1 = (user: IChatV2UserSchema): IUserInChatListSchema => {
  return {
    agencyName: user.agencyName,
    agentAccountType: user.agentAccountType,
    agentAvatarUrl: user.agentAvatarUrl,
    chatRole: user.chatRole,
    hasPublicProfile: user.hasPublicProfile,
    name: user.name || '',
    nameReplacementImageUrl: user.nameReplacementImageUrl,
    // TODO проверить отображение телефона
    phone: user.phones ? user.phones[0] : undefined,
    urlToAgentPublicProfile: user.urlToAgentPublicProfile || '',
    userId: user.userId,
  };
};
